import { NavigateFunction } from 'react-router-dom'
import { resolveIndustryPath } from '../services/apis/industry'

export const CLASSIFICATION_FIELD_CODES = {
    macroEconomicSector: 1,
    sector: 2,
    industryType: 3,
    industry: 4,
} as const

export type ClassificationFieldCode = keyof typeof CLASSIFICATION_FIELD_CODES

export const isClassificationFieldCode = (fieldCode: string): fieldCode is ClassificationFieldCode =>
    fieldCode in CLASSIFICATION_FIELD_CODES

export const buildIndustryPath = (segments: string[]) =>
    `/industries/${segments.join('/')}`

const pathCache = new Map<string, string[]>()

export const navigateToIndustryLevel = async (
    securityCode: string,
    fieldCode: string,
    navigate: NavigateFunction,
) => {
    if (!isClassificationFieldCode(fieldCode)) return

    const depth = CLASSIFICATION_FIELD_CODES[fieldCode]
    let segments = pathCache.get(securityCode)

    if (!segments) {
        const response = await resolveIndustryPath(securityCode)
        segments = [...response.slugPathSegments]
        if (segments.length > 0) {
            pathCache.set(securityCode, segments)
        }
    }

    if (!segments.length) return
    navigate(buildIndustryPath(segments.slice(0, depth)))
}
